<template>
  <DatatableReportV3
    title="Balance Due Customers"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // The default sort is by position, so it moves with the classification
    // columns to stay on the same column.
    const classificationColumns = customerClassificationColumns();

    return {
      config: {
        responsive: true,
        order: [[2 + classificationColumns.length, "desc"]],
        columns: [
          ...classificationColumns,
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 6 },
          { data: "customer_phone", title: "Phone", responsivePriority: 3 },
          {
            data: "address",
            title: "Billing Address",
            orderable: false,
            responsivePriority: 7
          },
          {
            data: "last_invoice_date",
            title: "Last Invoice",
            searchable: false,
            responsivePriority: 5
          },
          {
            data: "invoices",
            className: "text-center",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoices,
            footerClassName: "text-right",
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "balance",
            title: "Balance Due",
            className: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.balance,
            footerClassName: "text-right",
            searchable: false,
            responsivePriority: 2
          }
        ],
        vueComponents: []
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Balance Due Customers" });
  }
};
</script>

<style lang="scss" scoped></style>
